export const DSComboBoxName = 'DSCombobox';

export const DSComboboxSlots = {
  CONTAINER: 'root',
  INPUT_WRAPPER: 'input-wrapper',
  INPUT: 'input',
};
